function searchdivtoggle() {
  $('.new-search-bar').toggle('slow', 'swing');
}

$(document).ready(function () {
  if ($('body').hasClass('template-search')) {
    searchdivtoggle();
  }
  $(document).on('click','.predictive-search-tab-li', function(){
    let tab = $(this).attr('data-type');
    $('.predictive-search-tab-results').addClass('hide');
    $('.predictive-search-tab-result-'+tab).removeClass('hide');
    $('.predictive-search-tab-li').removeClass('active');
    $(this).addClass('active');
  });
  $(document).on('click', '.mobile-search-icon', function () {
    $('.new-search-bar').addClass('active');
    $('html').addClass('lock-scroll');
  });
});

function searchdivtoggle() {
  const searchBar = document.getElementById('searchBar');
  const searchButton = document.getElementById('searchButton');
  const searchCloseButton = document.getElementById('SearchClose');
  const isExpanded = (searchCloseButton && searchCloseButton.getAttribute('aria-expanded') === 'true');
  const searchiconButton = document.getElementById('searchBarbutton');
  const searchForm = document.getElementById('searchBar');

  // if (searchForm.style.display === 'none') {
  //   searchForm.style.display = 'block';
  //   searchiconButton.setAttribute('aria-expanded', 'true');
  // } else {
  //   searchForm.style.display = 'none';
  //   searchiconButton.setAttribute('aria-expanded', 'false');
  // }

  // if (isExpanded) {
  //   // Collapse the search bar
  //   searchBar.style.display = 'none';
  //   // searchCloseButton.setAttribute('aria-expanded', 'false');
  //   // searchButton.setAttribute('aria-expanded', 'false');
  // } else {
  //   // Expand the search bar
  //   searchBar.style.display = 'block';
  //   // searchCloseButton.setAttribute('aria-expanded', 'true');
  //   // searchButton.setAttribute('aria-expanded', 'true');
  // }
}

// Announcement Bar Slider new
(function () {
  var sliders = document.querySelectorAll('.announcement-slider');

  sliders.forEach(function (slider) {
    var slides = slider.querySelectorAll('.announcement-slide');
    if (slides.length <= 1) return;

    var current = 0;
    var interval = parseInt(slider.dataset.interval) || 3000;

    function nextSlide() {
      var prev = current;
      current = (current + 1) % slides.length;

      slides[prev].classList.add('exit');
      slides[prev].classList.remove('active');
      slides[current].classList.add('active');

      setTimeout(function () {
        slides[prev].classList.remove('exit');
      }, 500);
    }

    setInterval(nextSlide, interval);
  });
})();

// Announcement Bar Slider new end